import { render, staticRenderFns } from "./sztd.vue?vue&type=template&id=f5974f6e&scoped=true"
import script from "./sztd.vue?vue&type=script&lang=js"
export * from "./sztd.vue?vue&type=script&lang=js"
import style0 from "./sztd.vue?vue&type=style&index=0&id=f5974f6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5974f6e",
  null
  
)

export default component.exports